import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { axiosClient } from '@as-react/common-utils';
import { Cookie } from '@as-react/common-types';
import { cookieConsentSettingsParser, CookieUtil } from '@as-react/common-utils';
import CookiePreferences from './CookiePreferences';
import CookiePrivacy from './CookiePrivacy';
import { PopoverPosition, PopoverHeaderAlign, Image, ImageSize, Box, Heading, HeadingType, Text, TextType, TextSize, Button, ButtonVariant, IconName, IconSize, Popover, PopoverType, usePrevious, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { EventUtil } from '@as-react/common-utils';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import BrowserUtil from '../../../util/BrowserUtil';
import { EventEnum } from '@as-react/common-types';
import { COOKIE_CONSENT_ACCEPTED } from '../../../constants/StorageKeysConstants';
import { getImageFromCdn } from '../../../util/ImageUtil';
export const FUNCTIONAL_KEY = 'functional';
const CookieMessage = ({ cookieConsentAcceptAll, analyticsCookieConsentOpenPreferences, cookieConsentUpdated, cookieConsentSettingAvailable, cookieConsentSettings, logo, panel1, panel2, }) => {
    const { defaultRequestParams, servicesEndpoint, imageCdnPrefix } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    const [open, setOpen] = useState(!LocalStorageUtil.getItem(COOKIE_CONSENT_ACCEPTED));
    const [isCookiePreferencesOpen, setIsCookiePreferencesOpen] = useState(false);
    const [isCookiePreferenceOpen, setIsCookiePreferenceOpen] = useState(false);
    const [isReOpen, setIsReOpen] = useState(false);
    const [isCookiePrivacyOpen, setIsCookiePrivacyOpen] = useState(false);
    const [checkedPreferences, setCheckedPreferences] = useState({});
    const [initialCheckedPreferences, setInitialCheckedPreferences] = useState({});
    const [isCookieModalOpen, setIsCookieModalOpen] = useState(false);
    const [privacyData, setPrivacyData] = useState('');
    const [preferenceData, setPreferenceData] = useState('');
    const [isBrowserInstagram, setIsBrowserInstagram] = useState(false);
    const isCookiePreferencesOpenPrevValue = usePrevious(isCookiePreferencesOpen);
    const onCookiePreferencesClose = () => {
        setIsCookiePreferencesOpen(false);
        setCheckedPreferences(initialCheckedPreferences);
    };
    const onCookiePrivacyClose = () => {
        setIsCookiePrivacyOpen(false);
        setOpen(true);
    };
    const convertCookieGroupsToObject = (data = cookieConsentSettings) => {
        if (panel2 === null || panel2 === void 0 ? void 0 : panel2.cookieGroups) {
            return panel2.cookieGroups.reduce((obj, item) => {
                obj[item.key] = data[item.key] || item.key === FUNCTIONAL_KEY;
                return obj;
            }, checkedPreferences);
        }
        return {};
    };
    const handlePopoverClose = () => {
        setOpen(false);
    };
    const showCookiePreference = (cookieGroup) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const detailLink = (_a = panel2.cookieGroups.find((group) => group.key === cookieGroup.key)) === null || _a === void 0 ? void 0 : _a.detailLink;
        const axiosConfig = {
            method: 'GET',
            url: detailLink,
        };
        try {
            const res = yield axiosClient.request(axiosConfig);
            setPreferenceData(res.data);
            setIsCookiePreferenceOpen(true);
            setIsCookiePreferencesOpen(false);
        }
        catch (_b) { }
    });
    const getLogoUrl = () => getImageFromCdn(logo, imageCdnPrefix);
    useEffect(() => {
        setCheckedPreferences(convertCookieGroupsToObject());
        setInitialCheckedPreferences(convertCookieGroupsToObject());
        setIsBrowserInstagram(BrowserUtil.isBrowserInstagram());
        EventUtil.listen(EventEnum.COOKIE_CONSENT_PREFERENCES, () => {
            const cookieConsentSettingsUpdated = cookieConsentSettingsParser(decodeURIComponent(CookieUtil.get(Cookie.CONSENT_SETTING)));
            setIsReOpen(true);
            setIsCookiePreferencesOpen(true);
            setCheckedPreferences(convertCookieGroupsToObject(cookieConsentSettingsUpdated));
        });
    }, []);
    useEffect(() => {
        if (!LocalStorageUtil.getItem(COOKIE_CONSENT_ACCEPTED) &&
            (isCookiePreferencesOpen || isCookiePrivacyOpen || isReOpen)) {
            handlePopoverClose();
        }
        else if (!isCookiePreferencesOpen && !isCookiePreferenceOpen && !isReOpen) {
            setOpen(true);
        }
    }, [isCookiePreferencesOpen, isCookiePrivacyOpen, isReOpen]);
    useEffect(() => {
        if (isCookiePreferencesOpen !== isCookiePreferencesOpenPrevValue && isCookiePreferencesOpen) {
            analyticsCookieConsentOpenPreferences(checkedPreferences);
        }
    }, [isCookiePreferencesOpen, isCookiePreferencesOpenPrevValue]);
    useEffect(() => {
        if (LocalStorageUtil.getItem(COOKIE_CONSENT_ACCEPTED)) {
            setOpen(false);
            setIsCookieModalOpen(false);
        }
        if (!isCookieModalOpen && !LocalStorageUtil.getItem(COOKIE_CONSENT_ACCEPTED)) {
            setOpen(true);
            setIsCookieModalOpen(true);
        }
    }, [isCookieModalOpen]);
    const showCookiePreferences = (e) => {
        e.preventDefault();
        setIsCookiePreferencesOpen(true);
    };
    const onCookiePreferenceClose = () => {
        setPreferenceData('');
        setIsCookiePreferenceOpen(false);
        setIsCookiePreferencesOpen(true);
    };
    const showCookiePrivacy = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        const axiosConfig = {
            method: 'GET',
            url: panel1.privacyLinkHref,
        };
        try {
            const res = yield axiosClient.request(axiosConfig);
            setPrivacyData(res.data);
            setIsCookiePrivacyOpen(true);
        }
        catch (_a) { }
    });
    const saveCookiePreferences = () => __awaiter(void 0, void 0, void 0, function* () {
        const axiosConfig = {
            method: 'POST',
            data: checkedPreferences,
            url: `${servicesEndpoint}api/eprivacy/consent`,
            params: defaultRequestParams,
            withCredentials: true,
        };
        try {
            yield axiosClient.request(axiosConfig);
            setIsCookiePreferenceOpen(false);
            setIsCookiePreferencesOpen(false);
            handlePopoverClose();
            EventUtil.dispatch(EventEnum.COOKIE_CONSENT_PREFERENCES_UPDATED);
            LocalStorageUtil.setItem(COOKIE_CONSENT_ACCEPTED, true);
            setIsReOpen(true);
        }
        catch (_a) { }
    });
    const updateCookiePreferences = () => __awaiter(void 0, void 0, void 0, function* () {
        yield saveCookiePreferences();
        cookieConsentUpdated(checkedPreferences);
    });
    const changeCookiePreference = (e) => {
        const { value } = e.currentTarget;
        if (value === FUNCTIONAL_KEY) {
            return;
        }
        setCheckedPreferences((prevPreferences) => (Object.assign(Object.assign({}, prevPreferences), { [value]: !prevPreferences[value] })));
    };
    const acceptAllCookies = () => {
        setCheckedPreferences(Object.keys(checkedPreferences).reduce((obj, item) => {
            obj[item] = true;
            return obj;
        }, checkedPreferences));
        cookieConsentAcceptAll(checkedPreferences);
        saveCookiePreferences();
    };
    if ((LocalStorageUtil.getItem(COOKIE_CONSENT_ACCEPTED) && !isCookiePreferencesOpen && !isCookiePreferenceOpen) ||
        (!isReOpen && (cookieConsentSettingAvailable || !panel1))) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Popover, { noClose: true, disableClickOutside: true, anchorEl: open, type: PopoverType.MODAL_SSR, position: PopoverPosition.BOTTOM, onClose: handlePopoverClose, headerAlign: PopoverHeaderAlign.CENTER, withHeader: !isMobile, noAnimation: true, title: _jsx(Image, { src: getLogoUrl(), size: ImageSize.COOKIE_BRAND_LOGO }), children: _jsxs(Box, { mobile: {
                        spacing: {
                            marginTop: 2,
                            marginLeft: 2,
                            marginRight: 2,
                            marginBottom: isBrowserInstagram ? 10 : 2,
                        },
                    }, tablet: {
                        spacing: {
                            marginTop: 0,
                            marginLeft: 4,
                            marginRight: 4,
                            marginBottom: 4,
                        },
                    }, children: [_jsx(Box, { mobile: {
                                spacing: {
                                    marginBottom: 1,
                                },
                            }, tablet: {
                                spacing: {
                                    marginBottom: 1.5,
                                },
                            }, children: _jsx(Heading, { type: HeadingType.TITLE, children: panel1.title }) }), _jsxs(Text, { type: TextType.CONTENT, children: [_jsx(Text, { size: TextSize.INHERIT, html: panel1.description }), _jsx(Box, { mobile: { spacing: { marginTop: 2 } }, children: _jsx(Button, { onClick: showCookiePrivacy, variant: ButtonVariant.LINK, text: panel1.privacyLinkText }) })] }), _jsx(Box, { mobile: {
                                spacing: {
                                    marginTop: 3,
                                    marginBottom: 1.5,
                                },
                            }, tablet: {
                                spacing: {
                                    marginTop: 5,
                                    marginBottom: 2,
                                },
                            }, children: _jsx(Button, { id: "accept-all-cookies", text: panel1.btnLabel, fill: true, onClick: acceptAllCookies, iconRight: {
                                    name: IconName.COOKIE_BITE_SOLID,
                                    size: IconSize.MEDIUM,
                                } }) }), _jsx(Button, { onClick: showCookiePreferences, variant: ButtonVariant.LINK, text: panel1.moreOptions })] }) }), _jsx(CookiePreferences, { checkedPreferences: checkedPreferences, panel2: panel2, isCookiePreferenceOpen: isCookiePreferenceOpen, onCookiePreferenceClose: onCookiePreferenceClose, setIsCookiePreferenceOpen: setIsCookiePreferenceOpen, isCookiePreferencesOpen: isCookiePreferencesOpen, onCookiePreferencesClose: onCookiePreferencesClose, logoUrl: getLogoUrl(), saveCookiePreferences: updateCookiePreferences, changeCookiePreference: changeCookiePreference, showCookiePreference: showCookiePreference, preferenceData: preferenceData }), _jsx(CookiePrivacy, { privacyData: privacyData, isCookiePrivacyOpen: isCookiePrivacyOpen, onCookiePrivacyClose: onCookiePrivacyClose, logoUrl: getLogoUrl() })] }));
};
export default CookieMessage;
